/// <reference path="ModelTargetGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class ModelTargetPickerGrid extends SiteEntityGrid<ModelTargetRow, ModelTargetPickerOptions> {

        protected getColumnsKey() { return 'Data.ModelTargetPicker'; }
        protected getDialogType() { return ModelTargetDialog; }
        protected getIdProperty() { return ModelTargetRow.Fields.TargetCode; }
        protected getLocalTextPrefix() { return ModelTargetRow.localTextPrefix; }
        protected getService() { return ModelTargetService.baseUrl; }

        private rowSelection: Serenity.GridRowSelectionMixin;
        private expandTo: ExpandToLevelEditor;
        private focusToKey: string;
        private focusToKeys: Q.Dictionary<boolean>;

        constructor(container: JQuery, opt: ModelTargetPickerOptions) {
            super(container, opt);

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);

            if (opt.single) {
                var rs = this.rowSelection as any;
                var self = this;
                this.slickGrid.onHeaderClick.subscribe(function (e1, u) {
                    if ($(e1.target).hasClass('select-all-items')) {
                        Q.clearKeys(rs.include);
                        rs.updateSelectAll();
                        self.view.setItems(self.view.getItems(), true);
                    }
                });

                this.slickGrid.onClick.subscribe(function (e, p) {
                    if ($(e.target).hasClass('select-item')) {
                        var item = self.view.getItem(p.row);
                        var id = item[self.getIdProperty()].toString();
                        if (!rs.include[id]) {
                            Q.clearKeys(rs.include);
                        }
                        else {
                            Q.clearKeys(rs.include);
                            rs.include[id] = true;
                        }
                        self.view.setItems(self.view.getItems(), true);
                    }
                });
            }

            this.setEquality(ModelTargetRow.Fields.ModelCode, this.options.modelCode || "-1");

            new Serenity.TreeGridMixin({
                grid: this,
                getParentId: x => this.getParentId(x),
                initialCollapse: () => false,
                toggleField: "TargetCode"
            });

            this.expandTo = Serenity.Widget.create({
                type: ExpandToLevelEditor,
                element: el => el.css('float', 'left')
                    .css('width', '150px')
                    .css('margin-right', "0")
                    .insertAfter(this.toolbar.element.find('.s-QuickSearchBar'))
            });

            this.expandTo.changeSelect2(e => {
                var level = Q.toId(this.expandTo.value);
                if (level != null)
                    this.expandToLevel(level);
            });

            this.expandTo.modelCode = this.options.modelCode;
        }

        protected expandToLevel(level: number) {
            var items = this.view.getItems();
            for (var item of items) {
                Serenity.SlickTreeHelper.setCollapsedFlag(item,
                    level == 0 || (level > 0 && item.Level >= level));
            }
            this.view.setItems(items, true);
        }

        getParentId(x: ModelTargetRow) {
            if (x.Level <= 1)
                return null;

            var s = "";
            for (var i = 1; i < x.Level; i++) {
                if (i > 1)
                    s += "/";
                s += x["Code" + i];
            }

            return s;
        }

        private searchText: string;

        protected createQuickSearchInput() {
            
			Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text, done) => {
				this.searchText = Select2.util.stripDiacritics(text || '').toLowerCase();
                this.view.setItems(this.view.getItems(), true);
                done && done(true);
            });
        }

        protected onViewFilter(item: ModelTargetRow): boolean {
            if (!super.onViewFilter(item)) {
                return false;
            }

            if (!Serenity.SlickTreeHelper.filterById(item, this.view, x => this.getParentId(x)))
                return false;

            if (this.focusToKey != null &&
                this.focusToKeys != null &&
                !this.focusToKeys[item.TargetCode])
                return false;
        
            if (!this.searchText)
				return true;

            return this.containsSearchText(item) || Q.any(this.getDescendants(item), x => this.containsSearchText(x));
        }

        protected onViewProcessData(response: Serenity.ListResponse<ModelTargetRow>) {
            this._byParentId = null;
            this.focusToKey = null;
            this.focusToKeys = null;

            return super.onViewProcessData(response);
        }

        private getCode(item: ModelTargetRow) {
			if (item.TargetCode == "-1")
				return item.Code1;

			return (item["Code" + item.Level] || '');
        }

		private getName(item: ModelTargetRow) {
			if (item.TargetCode == "-1")
				return item.Name1;

			return (item["Name" + item.Level] || '');
		}

        private containsSearchText(item: ModelTargetRow): boolean {
            return Select2.util.stripDiacritics(this.getCode(item)).toLowerCase().indexOf(this.searchText) >= 0 ||
                Select2.util.stripDiacritics(this.getName(item)).toLowerCase().indexOf(this.searchText) >= 0;
        }
        
        gridPersistanceFlags() {
            var flags = super.gridPersistanceFlags();
            flags.sortColumns = false;
            return flags;
        }

        protected getColumns() {

            var columns = super.getColumns();
            
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            columns[0].headerFilterType = Serenity.HeaderFilterType.disabled;

            Q.first(columns, x => x.field == "FocusTo").format = ctx => {
                var targetCode = (ctx.item as ModelTargetRow).TargetCode;
                if (targetCode == "-1")
                    return "";

                return '<a class="inline-action focus-to" title="Focus on this row"><i class="fa fa-crosshairs ' + 
                    (this.focusToKey === targetCode ? 'text-red' : 'text-gray') + '"></i></a>';
            };

            Q.first(columns, x => x.field == "ExpandCollapseDescendants").format = ctx => {
                var item = ctx.item as ModelTargetRow;
                var children = this.byParentId[item.TargetCode];
                if (!children || !children.length)
                    return "";

                if (!item['_collapsed'] && !Q.any(children, c => {
                    var cc = this.byParentId[c.TargetCode];
                    return cc && cc.length > 0;
                })) {
                    return "";
                }

                var anyCollapse = item['_collapsed'] || Q.any(children, c => {
                    var cc = this.byParentId[c.TargetCode];
                    return cc && cc.length > 0 && !!c['_collapsed'];
                });
                
                return '<a class="inline-action expand-collapse-descendants" title="' + 
                    (anyCollapse ? "expand-descendants" : "collapse-descendants") +
                    '"><i class="mdi ' + (anyCollapse ? "mdi-expand-all-outline" : "mdi-collapse-all-outline") + ' text-black"></i></a>';
            };

            Q.first(columns, x => x.field == "TargetCode").format = this.itemLink(null, null, ctx => {
                    var item = ctx.item as ModelTargetRow;
                    if (item.TargetCode == "-1")
                        return item.Code1;

                    return (item["Code" + item.Level] || '');
                });

            Q.first(columns, x => x.field == "TargetName").format = this.itemLink(null, null, ctx => {
                    var item = ctx.item as ModelTargetRow;
                    if (item.TargetCode == "-1")
                        return item.Name1;

                    return (item["Name" + item.Level] || '');
                });

            Q.first(columns, x => x.field == "Level").format = ctx => {
                var item = ctx.item as ModelTargetRow;
                var level = item.Level;
                if (!level || level < 1 || level > 10)
                    return "";

                return level.toString();
            };

            Q.first(columns, x => x.field == "LevelName").format = ctx => {
                var item = ctx.item as ModelTargetRow;
                var level = item.Level;
                if (!level || level < 1 || level > 10)
                    return "";

                var model = ModelRow.getLookup().itemById[this.options.modelCode];
                if (!model)
                    return "";

                return(model['LevelName' + level] || '');
            };

            return columns;
        }

        usePager() {
            return false;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getPersistanceStorage() {
            return null;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != 'add-button');
            return buttons;
        }

        get selectedItems() {
            return this.rowSelection.getSelectedKeys().map(x => this.view.getItemById(x));
        }

        get value() {
            return this.rowSelection.getSelectedKeys();
        }

        set value(value: string[]) {
            this.rowSelection.clear();
            this.rowSelection.setSelectedKeys(value || []);
        }

        private _criteria: any[];

        set criteria(value: any[]) {
            if (this._criteria != value) {
                this._criteria = value;
            }
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            if (this._criteria != null)
                request.Criteria = Serenity.Criteria.and(request.Criteria, this._criteria);

            return true;
        }

        private _byParentId: Q.Grouping<ModelTargetRow>;

        private get byParentId() {
            if (this._byParentId)
                return this._byParentId;

            this._byParentId = Q.toGrouping(this.view.getItems(), x => this.getParentId(x));
            return this._byParentId;
        }

		private getParents(item: ModelTargetRow, targetClass: boolean = false): ModelTargetRow[] {
			let result: ModelTargetRow[] = [];
			while (true) {
				var parentId = this.getParentId(item);
				if (parentId == null || (!targetClass && parentId == '-1'))
					return result;
				item = this.view.getItemById(parentId);
				if (item == null)
					return result;
				result.push(item);
			}
		}

		private getDescendants(item: ModelTargetRow): ModelTargetRow[] {
			let result: ModelTargetRow[] = [];
            let byParentId = this.byParentId;
            let stack = [item];
            while (stack.length > 0) {
                let i = stack.pop();
                let children = byParentId[i.TargetCode];
                if (!children)
                    continue;

                for (let child of children) {
                    result.push(child);
                    stack.push(child);
                }
            }

            return result;
		}

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as ModelTargetRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('focus-to')) {
                    if (this.focusToKey === item.TargetCode) {
                        this.focusToKey = null;
                        this.focusToKeys = null;
                    }
                    else {
                        this.focusToKey = item.TargetCode;
                        this.focusToKeys = {};
                        this.focusToKeys["-1"] = true;
                        this.focusToKeys[item.TargetCode] = true;
                        for (var x of this.getParents(item))
                            this.focusToKeys[x.TargetCode] = true;
                        for (var x of this.getDescendants(item))
                            this.focusToKeys[x.TargetCode] = true;
                    }

                    this.view.refresh();
                    this.slickGrid.invalidate();
                }
                else if (target.hasClass("expand-collapse-descendants")) {
                    var descendants = this.getDescendants(item);
                    var anyChildrenExpanded = target.children('i').hasClass('mdi-collapse-all-outline');

                    this.view.beginUpdate();
                    try {
                        Serenity.SlickTreeHelper.setCollapsed([item], false);
                        Serenity.SlickTreeHelper.setCollapsed(descendants, anyChildrenExpanded);
                    }
                    finally {
                        this.view.endUpdate();
                    }
                    this.slickGrid.invalidate();
                }
            }
        }
    }
}